import { api } from "../../App/services/api";
function memberHandbookURL() {
    return api.get("/arts/memberHandbook");
}
export default { memberHandbookURL: memberHandbookURL };
